import React from "react";

import PropTypes from "prop-types";
import classnames from "classnames";

import "./CardIcon.scss";

const CardIcon = ({ className = "", cardType }) => {
	return (
		<div
			className={classnames(className, {
				"payment-card-icon": true,
				[`payment-card-icon-${cardType}`]: true,
			})}
		/>
	);
};

CardIcon.propTypes = {
	cardType: PropTypes.string.isRequired,
	className: PropTypes.string,
};

CardIcon.defaultProps = {
	className: null,
};

export default CardIcon;



// WEBPACK FOOTER //
// ./src/apps/payment/components/CardIcon/index.jsx